import Model from "@/lib/model/model";

// 英语标签及考察点信息
const Tags = {
  // 发言长度标签
  speechLengthTag: {
    1: "所有题目回答内容较短",
    2: "部分题目回答内容较短"
    // 9: "长"
  },
  // 内容相关度标签
  contentRelevanceTag: {
    1: "所有题目的内容相关度较低",
    2: "部分题目的内容相关度较低",
    5: "内容相关度：中",
    6: "内容相关度：中（部分）",
    9: "内容相关度：高"
  },
  // 表达流利度
  pronFluencyLevel: {
    name: "表达流利度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人无法进行有效交流，只有基本问候和句子",
      2: "候选人有有限的交流能力，停顿和犹豫频繁",
      3: "候选人有基本交流能力，但表达有限",
      4: "候选人有一般交流能力，但表达稍显不流利",
      5: "候选人有较为流利的交流能力，但在复杂话题下犹豫",
      6: "候选人能流利地进行交流，但偶尔出现错误",
      7: "候选人能流利地进行复杂交流，仅有个别小错误",
      8: "候选人能非常流利地进行交流，只有个别小错误",
      9: "候选人表达非常流利，与母语者无异"
    }
  },
  // 发音准确度
  pronAccuracyLevel: {
    name: "发音准确度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人发音不清晰几乎无法理解",
      2: "候选人发音准确度有限，可能常常被他人误解",
      3: "候选人发音勉强清晰，但仍有明显的错误",
      4: "候选人发音基本准确，但有时会出现错误",
      5: "候选人发音准确度适中，大多数人能够理解",
      6: "候选人发音准确度良好，发音清晰，只有个别小错误",
      7: "候选人发音准确度高于大多数非母语使用者，极少错误",
      8: "候选人发音非常接近母语者水平",
      9: "候选人发音与母语者无差别"
    }
  },
  // 词汇丰富度
  lexicalRichnessLevel: {
    name: "词汇丰富度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人词汇极度匮乏，只能使用极其有限的词汇",
      2: "候选人使用词汇有限，只能进行简单的表达",
      3: "候选人能使用的词汇比较勉强，表达的内容有限",
      4: "候选人词汇丰富度比较普通，日常表达仍稍显受限",
      5: "候选人使用了相对适中词汇，能应对一般的日常对话，可能在复杂情况下受限",
      6: "候选人词汇丰富度较为良好，可能偶尔出现不准确的使用",
      7: "候选人词汇丰富度高，能够使用多种词汇和短语进行表达",
      8: "候选人词汇丰富度非常高，能轻松应对复杂场景",
      9: "候选人词汇丰富度极高，表达极具深度和广度"
    }
  },
  // 语法准确度
  grammarAccuracyLevel: {
    name: "语法准确度",
    level: {
      0: "无法表达或未回答或完全不匹配",
      1: "候选人表达内容很有限，语法错误频繁，句子理解困难",
      2: "候选人能使用简单的句型或依赖预先背诵的几句话，语法错误较多，影响句子理解",
      3: "候选人能熟练使用简单的句型，语法错误有时较多，简单句能基本理解",
      4: "候选人能使用简单与复杂的句型，复杂句型使用较少且灵活性有限，语法错误较多，复杂句型理解困难",
      5: "候选人能使用简单与复杂的句型，只有复杂句型语法错误，连接和转折得当，但通常会出错且会造成某些理解困难",
      6: "候选人能较熟练的使用一些复杂的语法结构，整体语法准确性高，只有复杂句式语法出现较少错误，但内容结构性逻辑性较差",
      7: "候选人能熟练使用复杂句子和段落进行多样表达，语法准确性只有轻微错误，但内容结构性逻辑性仍需加强，除极其偶然情况下出现的不当或简单的/非系统性错误外，大部分语句准确无误",
      8: "候选人语法多样性和准确性卓越，语法只有轻微错误，能使用各种复杂句子结构，表达内容有结构性逻辑性，除了出现英语为母语者也会犯的口误外，始终使用准确的语法结构",
      9: "候选人能非常准确和多样化的语法使用，语法完美无错误，表达结构逻辑无可挑剔，流利运用各种句式和复杂结构，有创造性表达"
    }
  }
};
// 综合评价结尾
const totalLevelText = [
  "候选人未作答或回答过于简短，无法考察英语能力水平",
  "候选人的英语口语水平无法用英语进行交流，只能使用极其有限的词汇进行简单的表达，难以理解和回应复杂的英语交流。",
  "候选人的英语口语水平基础薄弱，日常交流困难，仅能应对基本的问候和简单场景下的交流，表达受限，难以进行复杂对话和商务交流。",
  "候选人的英语口语水平能够进行简单日常交流，但在工作场景下可能会有一些交流障碍，表达不够流利，常常需要用简单句子进行表达。",
  "候选人的英语口语水平勉强能开展简单工作会话，能够应付基本的英语邮件和电话交流，但在复杂场景下可能会出现理解和表达困难。",
  "候选人的英语口语水平足够进行简单的工作交流，能够应对日常的工作场景，与外籍同事进行基本的工作交流和团队合作。",
  "候选人的英语口语水平基本满足业务交流需求，能够与国际合作伙伴进行简单的商务洽谈、项目讨论和日常沟通，表达清晰，准确传递意图。",
  "候选人的英语口语水平能够在全英文的工作/生活的大多数情境中进行有效的沟通交流，能够自如地参与商务会议、演讲和团队讨论。",
  "候选人的英语口语水平高于大多数非母语使用者，能够在全英文的工作/生活的大多数情境中进行有效的沟通交流，有信心处理复杂业务交流。",
  "候选人的英语口语水平接近母语水平，几乎没有语言障碍，在任何英语环境下都能自如交流，能够与母语者进行高水平的学术和专业讨论。"
];
// 示意图信息
export const overallInfo = [
  {
    text: "欠佳",
    color: "#F72D20"
  },
  {
    text: "中等",
    color: "#FF9B00"
  },
  {
    text: "优秀",
    color: "#19C976"
  }
];
export default class EnglishAssessmentResult extends Model {
  totalLevel = 0; // 综合等级 (0-9) 综合等级0表示无有效回答 子项等级-1表示无当前类目
  pronFluencyLevel = 0; // 表达流利度等级 (0-9)
  pronAccuracyLevel = 0; // 发音准确度等级 (0-9)
  lexicalRichnessLevel = 0; // 词汇丰富度等级 (0-9)
  grammarAccuracyLevel = 0; // 语法准确度等级 (0-9)
  speechLengthTag = 0; // 发言长度标签 1:全部发言短 2:部分发言短 9:全部发言长
  contentRelevanceTag = 0; // 内容相关度标签 1:全部差 2:部分差 5:全部中 6:部分中 9:全部高
  assessmentType = 0; // 评估类型 0自由说 1朗读题

  // 表达流利度
  unPronFluency() {
    return this.pronFluencyLevel > -1;
  }
  // 发音准确度
  unPronAccuracy() {
    return this.pronAccuracyLevel > -1;
  }
  // 词汇丰富度
  unLexicalRichness() {
    return this.lexicalRichnessLevel > -1 && this.assessmentType === 0;
  }
  // 语法准确度
  unGrammarAccuracy() {
    return this.grammarAccuracyLevel > -1 && this.assessmentType === 0;
  }

  // 内容相关标签
  isContentRelevance(): boolean {
    return [1, 2].includes(this.contentRelevanceTag);
  }
  // 发言长度标签
  isSpeechLength(): boolean {
    return [1, 2].includes(this.speechLengthTag);
  }
  // 标签
  getTags(key: string): string {
    return Tags[key][this[key]];
  }

  // 等级文案信息集合整理
  getLevel(key: string, total = false) {
    const level = this[key];
    let i = 0;
    if ([0, 1, 2].includes(level)) i = 0;
    if ([3, 4, 5, 6].includes(level)) i = 1;
    if ([7, 8, 9].includes(level)) i = 2;
    return {
      label: Tags[key]?.name,
      text: overallInfo[i].text,
      color: overallInfo[i].color,
      desc: total ? totalLevelText[level] : Tags[key].level[this[key]]
    };
  }
  // 表格
  getTable() {
    const tableList: any = [
      {
        name: "综合成绩(满级9)",
        level: this.totalLevel
      }
    ];
    if (this.assessmentType === 0) {
      // 若是自由说类型  多以下两个
      // 语法准确度
      if (this.unGrammarAccuracy())
        tableList.unshift({
          name: Tags["grammarAccuracyLevel"].name,
          level: this.grammarAccuracyLevel
        });
      // 词汇丰富度
      if (this.unLexicalRichness())
        tableList.unshift({
          name: Tags["lexicalRichnessLevel"].name,
          level: this.lexicalRichnessLevel
        });
    }
    // 发音准确度
    if (this.unPronAccuracy())
      tableList.unshift({
        name: Tags["pronAccuracyLevel"].name,
        level: this.pronAccuracyLevel
      });
    // 表达流利度
    if (this.unPronFluency())
      tableList.unshift({
        name: Tags["pronFluencyLevel"].name,
        level: this.pronFluencyLevel
      });
    return tableList;
  }
}
